import { render, staticRenderFns } from "./FavoriteExhibitors.vue?vue&type=template&id=0f35019b&scoped=true&"
import script from "./FavoriteExhibitors.vue?vue&type=script&lang=js&"
export * from "./FavoriteExhibitors.vue?vue&type=script&lang=js&"
import style0 from "./FavoriteExhibitors.vue?vue&type=style&index=0&id=0f35019b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f35019b",
  null
  
)

export default component.exports